import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        authToken: localStorage.getItem('token'),
    },

    getters: {

    },

    mutations: {
        setAuthToken(state, value) {
            state.authToken = value;
            if (value) {
                localStorage.setItem('token', value);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + value;
            } else {
                localStorage.removeItem('token');
                axios.defaults.headers.common['Authorization'] = undefined;
            }
        },
    },

    actions: {
        login({commit, state}, payload) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + '/api/login',
                    method: 'POST',
                    data: {
                        username: payload.login,
                        password: payload.password,
                    },
                }).then(resp => {
                    const token = resp.data.access_token;
                    commit('setAuthToken', token);
                    resolve(resp);
                }).catch(err => {
                    commit('setAuthToken', null);
                    reject(err)
                })
            });
        },
    },

    strict: process.env.NODE_ENV !== 'production'
})
